// import axios from 'axios'
import baseURL from '../baseUrl'

// 获取收货地址列表
export function addressList(param) {
  var url=baseURL?'/pc_userAddress':'/api/pc_userAddress'
  return axios({
    url,
    method: 'post',
    params: {
      user_id: param.uid,
      token: param.browser_token
    }
  })
}

// 设置默认收货地址
export function addressSetDefault(param) {
  var url=baseURL?'/pc_addressSetDefault':'/api/pc_addressSetDefault'
  return axios({
    url,
    method: 'post',
    params: {
      id: param.id,
      user_id: param.uid,
      token: param.browser_token
    }
  })
}

// 删除收货地址
export function addressDel(param) {
  var url=baseURL?'/pc_deletaAddress':'/api/pc_deletaAddress'
  return axios({
    url,
    method: 'post',
    params: {
      id: param.id,
      user_id: param.uid,
      token: param.browser_token
    }
  })
}

// 获取城市数组
export function getdata() {
  var url=baseURL?'/getdata':'/api/getdata'
  return axios({
    url,
    method: 'post'
  })
}

// 收货地址提交
export function shouhuoDizhisub(query) {
  if (query.type == 1) {
    var url=baseURL?'/pc_updateAddress':'/api/pc_updateAddress'
    return axios({
      url,
      method: 'post',
      params: {
        id: query.type == 1 ? query.id : '',
        type: query.type,
        address: query.address,
        mobile: query.mobile,
        user_id: query.uid,
        consignee: query.consignee,
        sheng: query.sheng,
        shi: query.shi,
        qu: query.qu,
        token: query.browser_token,
        status: query.status
      }
    })
  } else {
    var url=baseURL?'/pc_addressAdd':'/api/pc_addressAdd'
    return axios({
      url,
      method: 'post',
      params: {
        id: query.type == 1 ? query.id : '',
        type: query.type,
        address: query.address,
        mobile: query.mobile,
        user_id: query.uid,
        consignee: query.consignee,
        sheng: query.sheng,
        shi: query.shi,
        qu: query.qu,
        token: query.browser_token,
        status: query.status
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/api/shouhuo/shouhuo_dizhi.js